module.exports = __webpack_public_path__ + "media/application/images/ui/checkbox-a77100a8a38ad59b724c307d482a546b.png";